import { render, staticRenderFns } from "./UserGroupsBlock.vue?vue&type=template&id=4a809a56&scoped=true&"
import script from "./UserGroupsBlock.vue?vue&type=script&lang=js&"
export * from "./UserGroupsBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupsBlock.vue?vue&type=style&index=0&id=4a809a56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a809a56",
  null
  
)

export default component.exports